import React, {createContext} from "react";
import {WebSocketProvider} from './WebSocketContext';
import {AtendimentoProvider} from "./AtendimentoContext";
import {VoipProvider} from "./VoipContext";

export const AppContext = createContext({});

export function AppContextProvider ({children}) {

  return (
    <AppContext.Provider value={{}}>
      <WebSocketProvider>
        <AtendimentoProvider>
          <VoipProvider>
              {children}
          </VoipProvider>
        </AtendimentoProvider>
      </WebSocketProvider>
    </AppContext.Provider>
  )
}
